import {
  createContext,
  useContext,
  useState,
  SetStateAction,
  Dispatch,
  ReactNode,
} from 'react';
const contextToggle = createContext<ToggleSidebarContextType | undefined>(
  undefined
);
interface ToggleSidebarContextType {
  showSidebar: boolean;
  setShowSidebar: Dispatch<SetStateAction<boolean>>;
  isdarkMode:boolean;
  setIsDarkMode: Dispatch<SetStateAction<boolean>>;
}
interface ToggleSidebarProps {
  children: ReactNode;
}
export default function ToggleSidebarProvider({children}: ToggleSidebarProps) {
  const [showSidebar, setShowSidebar] = useState(true);
  const [isdarkMode, setIsDarkMode] = useState(true);
  return (
    <contextToggle.Provider value={{showSidebar, setShowSidebar, isdarkMode, setIsDarkMode}}>
      {children}
    </contextToggle.Provider>
  );
}

export function useToggleSidebar(){
  const toggleSidebarContext = useContext(contextToggle)
  if(!toggleSidebarContext) throw new Error("toggle side bar context used outside its scope")
  return toggleSidebarContext
}